u<template>
    <modal-component @close="close">
        <template v-slot:header>
            <h1>Request a withdrawal</h1>
        </template>

        <p class="">Thank you for all your support. Once you request a withdrawal, someone from our team will reach out to collect your latest PayPal/bank details.</p>
        
        <p class="mt-6">This request will be submitted for the amount <strong>${{ amount }}</strong>.</p>

        <template v-slot:footer>
            <progressable-button 
                type="submit"
                class="py-2 px-4 rounded-md bg-primary text-white"
                :state="'Requesting...'"
                :loading="requesting"
                @click.native="request">
                Request a withdrawal for ${{ amount }}
            </progressable-button>
        </template>
    </modal-component>
</template>

<script>
export default {

    props: {
        amount: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            requesting: false,
        }
    },
    methods: {
        request() {
            this.requesting = true;
            axios.post('/api/ambassador/withdrawals/requests')
                .then(response => {
                    this.$emit('resolve')
                })
                .catch(console.error)
                .finally(() => {
                    this.requesting = false;
                });
        },
        close() {
            this.$emit('close');
        }
    }
}
</script>